export default "__VITE_PUBLIC_ASSET__38acc61b__"